export const APP_INITIALIZE_START = 'APP_INITIALIZE_START';
export const APP_INITIALIZE_SUCCESS = 'APP_INITIALIZE_SUCCESS';
export const APP_INITIALIZE_FAILURE = 'APP_INITIALIZE_FAILURE';
export const APP_SET_INITIALIZED = 'APP_SET_INITIALIZED';
export const APP_GET_APPLIST = 'APP_GET_APPLIST';
export const APP_GET_APPLIST_SUCCESS = 'APP_GET_APPLIST_SUCCESS';
export const APP_GET_APPLIST_FAILURE = 'APP_GET_APPLIST_FAILURE';
export const APP_SET_INFO = 'APP_SET_INFO';
export const APP_SET_PAGE = 'APP_SET_PAGE';
export const APP_SET_LOADING = 'APP_SET_LOADING';
export const APP_REFRESH_ACTIVITY_START = 'APP_REFRESH_ACTIVITY_START';
export const APP_REFRESH_ACTIVITY_SUCCESS = 'APP_REFRESH_ACTIVITY_SUCCESS';
export const APP_REFRESH_ACTIVITY_FAILURE = 'APP_REFRESH_ACTIVITY_FAILURE';
export const APP_RESET = 'APP_RESET';

export const APP_SET_SHOW_TOUR = 'APP_SET_SHOW_TOUR';
export const APP_SET_TOUR_STEP = 'APP_SET_TOUR_STEP';

export const GDL_INIT = 'GDL_INIT';
export const GDL_INIT_SUCCESS = 'GDL_INIT_SUCCESS';
export const GDL_INIT_FAILURE = 'GDL_INIT_FAILURE';
export const GDL_QUIT = 'GDL_QUIT';
export const GDL_QUIT_SUCCESS = 'GDL_QUIT_SUCCESS';
export const GDL_QUIT_FAILURE = 'GDL_QUIT_FAILURE';
export const GDL_RESET = 'GDL_RESET';
export const GDL_RESET_SUCCESS = 'GDL_RESET_SUCCESS';
export const GDL_RESET_FAILURE = 'GDL_RESET_FAILURE';
